import { Grid, Typography } from '@mui/material'
import React from 'react'
import style from '../../Styles/ComponentStyles/GlobalBadgesCard/GlobalBadgesCard.module.scss'
import globalStyle from '../../Styles/ComponentStyles/global.module.scss'
import IconsColor from '../../Utils/IconsColor'

const GlobalBadgesCard = (props: any) => {

    const {
        bdgBackgroundColor,
        bdgFilter,
        image,
        cardHeadText,
        cardSubText,
        cardHeadTextColor,
        cardSubTextColor,
        bdgBorder
    } = props

    return (
        <>
            <Grid container className={globalStyle.wrapperHeight100}>
                <Grid item
                    xs={12}
                    className={`${style.badgeCardItem} ${globalStyle.wrapperHeight100}`}
                    sx={{
                        backgroundColor: bdgBackgroundColor ? bdgBackgroundColor : "rgba(255, 255, 255, 0.3)",
                        backdropFilter: bdgFilter ? bdgFilter : "blur(5px)",
                        border: bdgBorder ? bdgBorder : ""
                    }}
                >
                    <Grid container className={`${style.badgeContainer}`}>
                        <Grid item className={style.badgeIconItem}>
                            <img src={image} alt="" style={{ width: "100%", height: '100%', objectFit: "fill" }} />
                        </Grid>
                        <Grid item className={style.badgeContentItem}>
                            <Grid container>
                                <Grid item xs={12} sx={{ margin: '0px 0px 2px' }}>
                                    <Typography
                                        component={'span'}
                                        className={`${style.badgeHeadText}`}
                                        sx={{
                                            color: cardHeadTextColor ? cardHeadTextColor : "#45556C"
                                        }}
                                    >
                                        {cardHeadText ? cardHeadText : ""}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{ margin: '2px 0px 0px' }}>
                                    <Typography
                                        component={'span'}
                                        className={`${style.badgeSubText}`}
                                        sx={{
                                            color: cardSubTextColor ? cardSubTextColor : "#45556C"
                                        }}
                                    >
                                        {cardSubText ? cardSubText : ""}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}


export default GlobalBadgesCard